import React, { useEffect, useRef, useState } from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
import './Cart.css'
import Product from '../../Components/Product/Product'
import { Link} from 'react-router-dom'

import { useSelector , useDispatch} from 'react-redux'
import { fetchCartItems } from '../../features/User/UserAction'


export default function Cart() {
  const keypress = useRef()
  const dispatch = useDispatch();
  const {BookWormUser} = useSelector((state)=>state);
  
  const {cart} = BookWormUser;
  const [total,setTotal] = useState(0);

  const [toBuy,setToBuy] = useState([]);

  useEffect(() => {
    const keyDownHandler = event => {
      console.log('User pressed: ', event.key);

      if (event.key === 'Enter') {
        event.preventDefault();
        keypress.current.click();
    //    handleSearch(event)
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  });
  useEffect(() => {
    dispatch(fetchCartItems({userId:BookWormUser.userInfo._id}));
    console.log("cart le bhai : ",cart);
  }, [])


  return (
    <div className='Cart'>
      <Navbar colorRight="#5f2c3e" colorLeft="#5f2c3e" />
      <div className='cart-page'>
      <div className="CartBody">
        <div className="CartHeadings">
          <h3>Books in the cart</h3>
          <h3 className='price-heading'>Price</h3>
        </div>
        <hr />
        <div className="Products">
          {cart.map((product) => (
            <div key={product._id}>
            <Product name={product.title} id={product._id} price={product.price} img = {product.images[0]} author={product.authors[0]} setTotal = {setTotal} total={total} toBuy={toBuy} setToBuy={setToBuy} sellerId = {product.userId} sold={product.sold}/>
             
            </div>
          ))}
        </div>
      <div className="ProceedToCheckout">
        
          <div className='ProceedToCheckoutHeading'>
          <h4>Total : {total}</h4>
          </div>
           <Link style={(total === 0) ? { pointerEvents: 'none', opacity: '0.4' } : {}} state={{ books: toBuy, totalCost: total }} className='ProceedToCheckoutBtn' to='/checkout' ref={keypress} >  Proceed to checkout</Link>

      </div>
      </div>
      </div>
      <Footer/>
    </div>
  )
}
